import { Field, Form, Formik } from 'formik';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { IAddEditFormProps } from '../../../models/forms/IForm';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import FormikFormFileInput from '../../../shared-components/FormikFormHandlers/FormikFormFileInput';
import LoaderButton from '../../../shared-components/button/loader-button';
import Label from '../../../shared-components/label/label';
import { CloseModalIcon } from '../../../shared-components/svgs/svgs';
import './import-holiday-form.css';

const ImportHolidayForm = (props: IAddEditFormProps<any>) => {
  return (
    <>
      <Modal
        className="correction-modal fancy-modal"
        show={true}
        centered
        onHide={() => {}}
      >
        <Modal.Header>
          <Modal.Title>
            <FormattedMessage id="import_holiday" />
            <button
              onClick={props.onModalClosed}
              disabled={props.isLoading}
              className="Crossicons"
            >
              <CloseModalIcon />
            </button>
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={props.initialValues}
          enableReinitialize
          validateOnBlur={false}
          onSubmit={async (values) => {
            props.submitHandler(values);
          }}
        >
          {({ setFieldValue }) => {
            return (
              <Form className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} contained />
                ) : null}
                <Modal.Body>
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group formSet">
                        <Label
                          className="label-style  col-form-label"
                          required={true}
                          label="file"
                        />
                        <Field
                          data-testid="file"
                          className="form-control"
                          name="file"
                          value={undefined}
                          invalidcharacter={[' ']}
                          validcharacter={['@', '#', '$', '-', '_', '.']}
                          placeholder=""
                          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          as={FormikFormFileInput}
                          onChange={(
                            event: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            if (
                              event.target.files != null &&
                              event.target.files.length > 0
                            ) {
                              setFieldValue('file', event.target.files[0]);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="d-flex justify-content-center ">
                    <div className="row tab-action g-0">
                      <div className="col-12">
                        <Button
                          variant="light-danger"
                          type="button"
                          onClick={props.onModalClosed}
                          disabled={props.isLoading}
                        >
                          <FormattedMessage id="cancel" />
                        </Button>
                        <LoaderButton
                          type="submit"
                          isLoading={props.isLoading}
                          text="button_save"
                        />
                      </div>
                    </div>
                  </div>
                </Modal.Footer>
              </Form>
            );
          }}
        </Formik>
      </Modal>
    </>
  );
};

export default ImportHolidayForm;
